import type { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { EntitlementDeniedState, LoadingState } from "@odingard/design-system";
import { useAuth } from "../lib/auth";
import { useAsync } from "../lib/useAsync";
import { api } from "../lib/api";

export const CALENDAR_ENTITLEMENT = "calendar_ai.enabled";

export function hasCalendarEntitlement(
  entitlements: { key: string; status: string }[] | null | undefined,
): boolean {
  return entitlements?.some((e) => e.key === CALENDAR_ENTITLEMENT && ["ALLOWED", "TRIAL"].includes(e.status)) ?? false;
}

export function CalendarGuard({ children }: { children: ReactNode }) {
  const { activeOrg } = useAuth();
  const navigate = useNavigate();
  const orgId = activeOrg?.id ?? "";
  const state = useAsync(async () => (await api.entitlements(orgId)).entitlements, [orgId]);
  if (state.loading) return <LoadingState label="Checking your access…" />;
  if (!hasCalendarEntitlement(state.data)) {
    return <EntitlementDeniedState product="Calendar AI" onUpgrade={() => navigate("/pricing")} />;
  }
  return <>{children}</>;
}
